import { BrowserRouter, Route, Routes } from "react-router-dom";
import Error from "./views/ErrorPage";
import AuthChecker from "./components/auth/AuthChecker";
import LandingPage from "./views/LandingPage";
import Home from "./components/Home";
import Profile from "./components/Profile";

const routes = [
  {
    path: "/goals",
    component: Home,
    name: "Home",
    protected: true,
  },
  {
    path: "",
    component: LandingPage,
    name: "Login",
    protected: false,
  },
  {
    path: "/profile",
    component: Profile,
    name: "Profile",
    protected: true,
  },
  {
    path: "*",
    component: Error,
    name: "Error Screen",
    protected: false,
  },
];

function App() {
  return (
    <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                route.protected ? (
                  <AuthChecker>
                    <route.component />
                  </AuthChecker>
                ) : (
                  <route.component />
                )
              }
            />
          ))}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
